'use strict'

module.exports = require('./circuit')
